/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import settingPage from './setting-page';

// Components
import Accordion from 'shared/ui/components/Accordion.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';
import LocationsList from 'ui/components/meetings/locations/LocationsList.vue';

const __vue_script__ = {
    name: 'Locations',

    components: {
        Accordion,
        Toggler,
        LocationsList
    },

    mixins: [settingPage],

    data() {
        return {
            allowCustomLocations: false,
            allowVirtualMeetings: false
        };
    },

    computed: {
        virtualMeetingsSupported() {
            return this.event?.use_vonage_calls_in_chat;
        }
    },

    methods: {
        init() {
            try {
                this.allowCustomLocations = this.settings['custom-location'];
                this.allowVirtualMeetings = this.settings['virtual_meetings_enabled'];
            } catch (error) {
                console.error('[Locations] Could not load current settings', error);
            }
        },

        save() {
            this.$emit('save', {
                'custom-location': this.allowCustomLocations,
                'virtual_meetings_enabled': this.allowVirtualMeetings
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"locations",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('accordion',{attrs:{"headers-i18n-prefix":"meetings.settings.locations.configuration","default-open-item":"title","animated":true,"unlimited-height":true,"slim":true},scopedSlots:_vm._u([{key:"title",fn:function(ref){return [_c('validation-provider',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [(_vm.virtualMeetingsSupported)?_c('toggler',{attrs:{"name":"allow_virtual_meetings","on-label":"meetings.settings.locations.configuration.allow_virtual_meetings","off-label":"meetings.settings.locations.configuration.allow_virtual_meetings","hint":_vm.$t('meetings.settings.locations.configuration.allow_virtual_meetings_hint'),"errors":errors},model:{value:(_vm.allowVirtualMeetings),callback:function ($$v) {_vm.allowVirtualMeetings=$$v},expression:"allowVirtualMeetings"}}):_vm._e()]}}],null,true)}),_c('validation-provider',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('toggler',{attrs:{"name":"allow_custom_locations","on-label":"meetings.settings.locations.configuration.allow_custom_locations","off-label":"meetings.settings.locations.configuration.allow_custom_locations","hint":_vm.$t('meetings.settings.locations.configuration.allow_custom_locations_hint'),"errors":errors},model:{value:(_vm.allowCustomLocations),callback:function ($$v) {_vm.allowCustomLocations=$$v},expression:"allowCustomLocations"}})]}}],null,true)})]}}])}),_c('locations-list',{attrs:{"event":_vm.event,"module":_vm.module}}),_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary"},[_vm._v(_vm._s(_vm.$t('general.save')))])])],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Locations.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__